import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import classNames from 'classnames';
import DialogModal from '../../common/DialogModal';
import Typography from 'material-ui/Typography';
import BarLoader from '../../Parts/BarLoader';
import Buttons  from '../../Parts/Button';
import Button from 'material-ui/Button';
import HelpIcon from "../../Icons/HelpIcon";
import ArrowToolTip from "../../common/ArrowToolTip"
import { isPlanExpired } from '../../../utils/userUtils';
import { instanceOf } from 'prop-types';
import { withCookies, Cookies } from 'react-cookie';
import { SALES_DEMO_ACCOUNT_ID } from "../../../constants/Constants";
import { getExecutiveListUpdate } from '../../../redux/actions/ExecutiveList';
import { connect } from 'react-redux';
import { DAILY_NOTIFICATION_FILTER_CONFIG } from '../../../constants/ExecutiveListSearchKeyConstants';

const styles = () => ({
  defaultContainer: {
    minWidth: '600px',
    maxWidth: '1200px',
    margin: 0,
    display: "flex",
    flexDirection: "column",
    boxSizing: "border-box",
    background: "#FFFFFF",
    textAlign: "left",
    padding: '0px 25px 25px',
  },

  tipDialogContainer: {
    margin: 0,
    padding: '20px 115px 50px',
    textAlign: 'unset',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
  },

  subSectionHead: {
    fontSize: '13px',
    color: '#181819',
    fontWeight: 'bold',
    boxSizing: 'border-box',
    margin: '18px 0',
    borderRadius: '2px',
    padding: '12px 10px',
  },

  blue: {
    backgroundColor: '#F2F6FF',
  },

  red: {
    backgroundColor: '#FFF2F2',
  },

  green: {
    backgroundColor: '#E6FFEC',
  },

  yellow: {
    backgroundColor: '#FFF9E6',
  },

  listContainer: {
    marginBottom: 'auto',
  },

  row: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    boxSizing: 'border-box',
    padding: '14px 20px 14px 5px',
    justifyContent: 'space-between',
  },

  logo: {
    height: '37px',
    width: '37px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: '20px',
  },

  logoImg: {
    maxWidth: '37px',
    maxHeight: '37px',
  },

  textContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    position: 'relative',
    width: 'calc(100% - 47px)',
  },

  text: {
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    width: '100%',
    boxSizing: 'border-box',
    display: 'block',
  },

  moreBtnContainer: {
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    paddingTop: '13px',
    borderTop: '1px solid #D8DBDF',
  },

  moreBtn: {
    color: '#1A65FF',
    fontSize: '13px',
    cursor: 'pointer',

    '&:hover': {
      textDecoration: 'underline',
    }
  },

  tipButtonContainer: {
    display: 'flex',
    justifyContent: 'center',
  },

  tipButton: {
    border: 'solid 1px #D8DBDF',
    color: '#181819',
    fontSize: '13px',
    margin: '30px',
  },

  buttonContainer: {
    width: '100%',
    marginTop: '30px',
  },

  empty: {
    fontSize: '13px',
    color: "#71737B",
    width: 'calc(25% - 10px)',
    marginBottom: 'auto',
  },

  loadingContainer: {
    position: 'relative',
    height: '600px',
  },

  totalEmpty: {
    letterSpacing: '-0.15px',
    marginTop: '20px',
    textAlign: 'center',
    fontSize: '15px',
    whiteSpace: 'pre',
  },

  tip: {
    paddingBottom: '20px',
  },

  addedKeymanInfo: {
    letterSpacing: '-0.15px',
    marginTop: '20px',
    textAlign: 'center',
    fontWeight: 'bold',
    fontSize: '15px',
  },

  addedKeymanTotal: {
    fontSize: '36px',
    color: '#1A65FF',
    margin: '0 8px',
  },
});

class DailyNotificationDialog extends React.Component {
  initialState = {
    tip: DailyNotificationDialog.TIPS[Math.floor(Math.random() * DailyNotificationDialog.TIPS.length)]
  }

  constructor(props) {
    super(props);
    this.state = { ...this.initialState };
  }

  componentDidMount() {
    this.props.getExecutiveListUpdate()
  }

  handleClose = () => {
    const { user } = this.props;
    const date = new Date();
    const maxHour = 23;
    const maxMinute = 59;
    const maxSecond = 59;
    const limit = new Date(date.getFullYear(), date.getMonth(), date.getDate(), maxHour, maxMinute, maxSecond);
    // デモアカウントの場合はポップアップを1日1回ではなく毎回表示
    if (user && user.id !== SALES_DEMO_ACCOUNT_ID && process.env.REACT_APP_BUILD_ENV !== 'production') {
      this.props.cookies.set('showDailyNotificationDialog', 0, { path: '/', expires: limit });
    }
    this.props.toggleDialog();
  }

  handleFilter = ($queryKey, name) => {
    if ($queryKey) {
      this.props.handleUpdateFilter({
        [$queryKey]: name,
      });
    }
    this.props.toggleDialog();
  }

  calcColWidth = () => {
    const { addedKeymanTotalCount, delKeymanTotalCount, existsDepartmentTelKeymanTotalCount, recommendKeymanTotalCount } = this.props;

    const cols = [addedKeymanTotalCount, delKeymanTotalCount, existsDepartmentTelKeymanTotalCount, recommendKeymanTotalCount];
    const zeroCount = cols.filter(value => value === 0).length;
    const hundredPercent = 100;

    return "calc(" + (hundredPercent / (cols.length - zeroCount)) + "% - 10px)";
  }

  renderCol = (type, key) => {
    const { classes, addedKeyman, addedKeymanTotalCount, delKeyman, delKeymanTotalCount, existsDepartmentTelKeyman, existsDepartmentTelKeymanTotalCount, recommendKeyman, recommendKeymanTotalCount, disabled } = this.props;

    let totalCount;
    let keymans;
    let color;
    if (key === 'add_keyman_filter') {
      totalCount = addedKeymanTotalCount;
      keymans = addedKeyman;
      color = classes.blue;
    } else if (key === 'del_keyman_filter') {
      totalCount = delKeymanTotalCount;
      keymans = delKeyman;
      color = classes.red;
    } else if (key === 'exists_department_tel_keyman_filter') {
      totalCount = existsDepartmentTelKeymanTotalCount;
      keymans = existsDepartmentTelKeyman;
      color = classes.green;
    } else if (key === 'recommend_keyman_filter') {
      totalCount = recommendKeymanTotalCount;
      keymans = recommendKeyman;
      color = classes.yellow;
    } else {
      return null;
    }

    if (totalCount === 0) {
      return null;
    }

    const displayItemCount = 5;

    return (
      <div key={key} className={classes.listContainer} style={{ width: this.calcColWidth(), borderBottom: totalCount <= displayItemCount ? '1px solid #D8DBDF' : '' }}>
        <div className={classNames(classes.subSectionHead, color)}>
          {type.description ?
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <div>{type.label}</div>
              <ArrowToolTip
                text={type.description}
                tooltipMaxWidth={"200"}
                placement={"right"}
                style={{ marginBottom: '2px' }}
              >
                <HelpIcon
                  width={16}
                  height={16}
                  color="#71737B"
                />
              </ArrowToolTip>
            </div>
          : type.label}
        </div>
        {keymans.map((keyman, i) => this.renderRow(keyman, i, () => this.handleFilter(key, type.label)))}
        {totalCount > displayItemCount && (
          <div className={classes.moreBtnContainer}>
            <div
              className={classes.moreBtn}
              onClick={() => this.handleFilter(key, type.label)}
              style={{
                cursor: disabled ? "auto" : 'pointer',
                pointerEvents: disabled ? 'none' : 'auto',
                color: disabled ? "#1A65FF" : "#1A65FF"
              }}
            >
              …他{totalCount - displayItemCount}人を見る
            </div>
          </div>
        )}
      </div>
    );
  }

  renderRow = (item, index, handleFilter) => {
    const { classes, disabled } = this.props;

    return (
      <div
        className={classes.row}
        key={index}
        style={{
          cursor: disabled ? "auto" : 'pointer',
          pointerEvents: disabled ? 'none' : 'auto',
          borderTop: '1px solid #D8DBDF',
        }}
        onClick={() => {
          handleFilter();
          this.props.toggleExecDetailItemDialog(item);
        }}
      >
        <div className={classes.logo}>
          <img src={item.logo_path} alt="logo" className={classes.logoImg} />
        </div>
        <div className={classes.textContainer}>
          <Typography variant="subheading" className={classes.text} title={`${item.name} 様`}>
            {`${item.name} 様`}
          </Typography>
          <Typography variant="body1" className={classes.text} title={`${item.company_name} ${item.honorific}`}>
            {item.company_name} {item.honorific}
          </Typography>
        </div>
      </div>
    )
  }

  isAllColTotalCountZero = () => {
    const { isLoadingUpdatedKeyman, addedKeymanTotalCount, delKeymanTotalCount, existsDepartmentTelKeymanTotalCount, recommendKeymanTotalCount } = this.props;
    return isLoadingUpdatedKeyman === false && (addedKeymanTotalCount + delKeymanTotalCount + existsDepartmentTelKeymanTotalCount + recommendKeymanTotalCount === 0);
  }

  renderTitle = () => {
    const { addedKeymanTotalCount , classes} = this.props;

    if (addedKeymanTotalCount > 0) {
      return (
          <div className={classes.addedKeymanInfo}>
              本日、新しいキーマンが<span className={classes.addedKeymanTotal}>{addedKeymanTotalCount}人</span>更新されました。
          </div>
      );
    }
  }

  renderBody = () => {
    const { classes } = this.props;

    if (this.isAllColTotalCountZero()) {
      return (
        <div className={classes.totalEmpty}>
          <img alt="tip" src={require('../../../assets/images/find.png')} height="300" />
          <Typography variant="subheading" style={{ fontWeight: 'bold', marginTop: '30px' }}>{"【お役立ち情報】"}</Typography>
          <Typography variant="body2" style={{ marginTop: '15px' }}>{this.state.tip}</Typography>
        </div>
      );
    }

    return (
      <div className={classes.row} style={{ padding: '0' }}>
        {Object.entries(DAILY_NOTIFICATION_FILTER_CONFIG).map(([key, config]) =>
          this.renderCol(config, key)
        )}
      </div>
    )
  }

  renderCloseButton = () => {
    const { classes } = this.props;

    if (this.isAllColTotalCountZero()) {
      return (
        <div className={classes.tipButtonContainer}>
          <Button color="default" onClick={this.handleClose} className={classes.tipButton}>
            {"確認して閉じる"}
          </Button>
        </div>
      );
    }

    return (
      <div className={classes.buttonContainer}>
        <Buttons
          handleClickButton={this.handleClose}
          text="確認して閉じる"
          size="large"
          style={{ width: "100%" }}>
        </Buttons>
      </div>
      );
  }

  render() {
    const { classes, isOpen, toggleDialog } = this.props;

    return (
      <DialogModal
        title="お知らせ"
        open={isOpen}
        onClose={toggleDialog}
        maxWidth={false}
        classes={{
          contentContainer: this.isAllColTotalCountZero() ? classes.tipDialogContainer : classes.defaultContainer
        }}
      >
        <div>
          {(() => {
            if (this.props.isLoadingUpdatedKeyman) {
              return (
                <div className={classes.loadingContainer}>
                  <BarLoader type="color" size="large" width={200} />
                </div>
              )
            }

            return (
              <div>
                {this.renderTitle()}
                {this.renderBody()}
                {this.renderCloseButton()}
              </div>
            );
          })()}
        </div>
      </DialogModal>
    )
  }
}

DailyNotificationDialog.propTypes = {
  classes: PropTypes.object.isRequired,
  user: PropTypes.object,
  disabled: PropTypes.bool,
  isLoadingUpdatedKeyman: PropTypes.bool,
  getExecutiveListUpdate: PropTypes.func,
  handleUpdateFilter: PropTypes.func,
  // 更新されたキーマン
  addedKeyman: PropTypes.array,
  addedKeymanTotalCount: PropTypes.number,
  // 退任されたキーマン
  delKeyman: PropTypes.array,
  delKeymanTotalCount: PropTypes.number,
  // 部門電話番号が取得できたキーマン
  existsDepartmentTelKeyman: PropTypes.array,
  existsDepartmentTelKeymanTotalCount: PropTypes.number,
  // おすすめのキーマン
  recommendKeyman: PropTypes.array,
  recommendKeymanTotalCount: PropTypes.number,
  isOpen: PropTypes.bool.isRequired,
  toggleDialog: PropTypes.func.isRequired,
  cookies: instanceOf(Cookies).isRequired,
  toggleExecDetailItemDialog: PropTypes.func,
};

DailyNotificationDialog.TIPS = [
  "レターを送る準備はお済みでしょうか? \n メニューのヘルプよりレターに関することをご紹介してます。\n ぜひご覧くださいませ。",
  "Keyman LetterとSalesforce連携をすると \n レターを送付したキーマンや、フォロコールの音声を同期することができます。",
  "英字での企業名が見つからない場合は \n ローマ字で検索すると見つかる場合があります。",
  "レター文面作成機能を使うとAIがレターの内容を考えてくれます。\n メニューのヘルプよりお試しくださいませ。",
]

const mapStateToProps = (state) => {
  return {
    user: state.accountSetting.user,
    disabled: isPlanExpired(state.accountSetting.user),
    isLoadingUpdatedKeyman: state.executiveList.isLoadingUpdatedKeyman,
    // 更新されたキーマン
    addedKeyman: state.executiveList.addedKeyman,
    addedKeymanTotalCount: state.executiveList.addedKeymanTotalCount,
    // 退任されたキーマン
    delKeyman: state.executiveList.delKeyman,
    delKeymanTotalCount: state.executiveList.delKeymanTotalCount,
    // 部門電話番号が取得できたキーマン
    existsDepartmentTelKeyman: state.executiveList.existsDepartmentTelKeyman,
    existsDepartmentTelKeymanTotalCount: state.executiveList.existsDepartmentTelKeymanTotalCount,
    // レコメンドキーマン
    recommendKeyman: state.executiveList.recommendKeyman,
    recommendKeymanTotalCount: state.executiveList.recommendKeymanTotalCount,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    getExecutiveListUpdate() {
      dispatch(getExecutiveListUpdate());
    },
  }
};

export default withCookies(
  withStyles(styles)(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(DailyNotificationDialog)
  )
);



// WEBPACK FOOTER //
// ./src/components/ExecutiveList/dialogs/DailyNotificationDialog.jsx